export default __webpack_public_path__ + "static/media/logo-dark.493ce24f.png";